import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Article, Entite, Groupe, ModeDeFacturation,  ModeFacturationModel, Options, Select, QueovalDate, Formulaire } from '../../../models';
import { CoreService, HttpService, QueovalDateService } from '../../../services';
import { ToastService } from '../../../toast';
import { ActionCoService } from '../action-co-services/action-co.service';

@Component({
  selector: 'q-action-co-modefacturation',
  templateUrl: './action-co-modefacturation.component.html',
  styleUrls: ['./action-co-modefacturation.component.css']
})

export class ActionCoModeFacturationComponent implements OnInit {

  // Ident du pere de la relation sur le mode de facturation
  @Input() idObjet: string;
  @Input() idClient: string;
  // Indique si client ou objet facturable (client prospect mission affaire prestation convention...)
  @Input() mode: string;

  public modeFacturation: ModeDeFacturation;

  // Liste des selects
  public modeFacturationDisplay: Formulaire;

  // Sauvegarde en cours
  public SaveInprogress: Boolean = false;

  public dateF: string = '';
  public dateR: string = '';
  public txtEnregistrer: string = '';
  public txtInfo: string = '';
  public txtToolTip: string = '';

  /**
  * Boolean permettants la validation du mode de facturation
  */
  public isEntite: boolean;
  public isGroupe: boolean;
  public isArticle: boolean;
  public isDateDebut: boolean;
  public isEcheance: boolean;
  public isNbJour: boolean;
  public isOccurenceReglement: boolean;
  public isDateValid: boolean;
  public isModeReglement: boolean;

  constructor(
    public indParam: CoreService,
    private http: HttpService,
    public toast: ToastService,
    public httpClient: HttpClient,
    public actionCoService: ActionCoService,
    public dateService: QueovalDateService
  ) { }

  ngOnInit() {
    // initialisation des boolean
    this.isEntite = true;
    this.isGroupe = true;
    this.isArticle = true;
    this.isDateDebut = true;
    this.isEcheance = true;
    this.isNbJour = true;
    this.isOccurenceReglement = true;
    this.isDateValid = true;
    this.isModeReglement = true;   

    // Mode de facturation de la personne morale
    this.modeFacturation = new ModeDeFacturation();
    // Liste des combo pour le mode de facturation
    this.modeFacturationDisplay = new Formulaire();

    // Recuperation des listes pour le display du mode de facturation    
    this.http.getHttp<ModeFacturationModel>(`${this.indParam.AppParams.apiUrl}api/spefCompta/modeFacturation/MODEFACTURATIONDISPLAY/0/`).subscribe((dataListInit: ModeFacturationModel) => {
      if (!dataListInit.HasError) {
        this.modeFacturationDisplay = dataListInit.formulaire;
        // Récuperation du mode de facturation sur la personne morale (par défaut sur l'entité 1348)
        this.http.getHttp<ModeFacturationModel>(`${this.indParam.AppParams.apiUrl}api/spefCompta/modeFacturation/MODEFACTURATION/${this.idObjet}|${this.idClient}/`).subscribe((dataInit: ModeFacturationModel) => {
          if (!dataInit.HasError) {
            this.modeFacturation = dataInit.dataSave.modeFacturation;

            if (!this.dateService.IsNull(this.modeFacturation.dateDebutFacturation)) {                          
              this.modeFacturation.dateReglement = this.dateReglement(this.modeFacturation);
              this.dateF = this.dateService.ToString(this.modeFacturation.dateDebutFacturation);
              this.dateR = this.dateService.ToString(this.modeFacturation.dateReglement, 'dd/MM/yyyy');
            }
            this.txtEnregistrer = this.modeFacturation.origine === 'Client' ? "Enregistrer" : `Créer le mode de facturation ${this.mode}`;
            if (this.mode === 'client' || this.mode === 'prospect') {
              this.txtInfo = `ATTENTION le mode de facturation est unique sur un ${this.mode} et donc commun à toutes les actions CO du ${this.mode}`
            }
            this.txtToolTip = `Enregistrer le mode de facturation ${this.mode}`
          }
        });


      }
    });
  }

  // Enregistrment du mode de facturation
  public enregistrerMFA(): void {
    
    const model: ModeFacturationModel = new ModeFacturationModel();
    model.dataSave.client = new Select();
    model.dataSave.client.id = this.idClient;
    model.dataSave.mission = new Select();
    model.dataSave.mission.id = '0';
    model.dataSave.prestation = new Select();
    model.dataSave.prestation.id = '0';
    model.dataSave.convention = new Select();
    model.dataSave.convention.id = '0';
    switch (this.mode) {  
      case 'mission':
      case 'affaire':        
        model.dataSave.mission.id = this.idObjet;          
        break;
      case 'prestation':        
        model.dataSave.prestation.id = this.idObjet;
        break;
      case 'convention':
        model.dataSave.convention.id = this.idObjet;
        break;
      default:
        break;
    }

    this.SaveInprogress = true;
    model.dataSave.modeFacturation = JSON.parse(JSON.stringify(this.modeFacturation));
    model.Mode = 'UPDATEMODEFACTURATION';
    this.http.postHttp<ModeFacturationModel>(`${this.indParam.AppParams.apiUrl}api/spefCompta/modeFacturation`, model).subscribe((data: ModeFacturationModel) => {
      if (!data.HasError) {
        this.txtEnregistrer = "Enregistrer";
      }
      //else {
      //}
      this.SaveInprogress = false;
    });

  }

  // Entite de facturation
  public getEntite(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.entite.filter((c: Entite) => c.id === e.target.value)[0].value };
    this.modeFacturation.entiteFacturation = { id: option.value, value: option.text };
    const entite: Entite = this.modeFacturationDisplay.entite.filter((c: Entite) => c.id === e.target.value)[0];
    entite.groupes = entite.groupes;
    this.isEntite = this.modeFacturation.entiteFacturation.id !== '0';
  }

  // groupe de facturation
  public getGroupe(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.groupeFacturation.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.groupeFacturation = { id: option.value, value: option.text };
    this.isGroupe = this.modeFacturation.groupeFacturation.id !== '0';

  }

  // Familles de facturation
  public getGroupeFamille(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.groupeFamille.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.groupeFamille = { id: option.value, value: option.text };
  }

  // Articles
  public getGroupeArticle(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.article.filter((c: Article) => c.id === e.target.value)[0].value };
    for (const a of this.modeFacturationDisplay.article) {
      if (option.value === a.id) {
        this.modeFacturation.article = a;
        this.isArticle = this.modeFacturation.article.id !== '0';
        break;
      }
    }
  }

  // Ordre des lignes (deprecié)
  public getOrdreLigne(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.ordreLigne.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.ordreLigne = { id: option.value, value: option.text };
  }

  // Sous totaux (regroupement de lignes)
  public getGroupeLigne(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.groupeLigne.filter((c: Groupe) => c.code === e.target.value)[0].value };
    for (const g of this.modeFacturationDisplay.groupeLigne) {
      if (option.value === g.code) {
        this.modeFacturation.groupeLigne = g;
        break;
      }
    }
  }

  // Date de premiere edition
  public FormatDateDebutFacturationToShort(strDate: string): void {
    this.modeFacturation.dateDebutFacturation = this.dateService.FromString(strDate);
    this.isDateDebut = this.modeFacturation.dateDebutFacturation != null;
    this.updateDateReglement();
  }

  // Date de l'echeancier de facturation: Date emission ou fin de mois
  public checkFinMois(value: boolean): void {
    this.modeFacturation.facturationFindemois = value;
  }

  // Mode de calcul Forfait ou Temps passe
  public checkType(value: boolean): void {
    if (value) {
      this.modeFacturation.type = 2;
    } else {
      this.modeFacturation.type = 1;
    }
  }

  // Nombre de facture
  public changeNbOccur(value: string): void {
    this.isEcheance = value !== '';
    if (value !== '') {
      this.isEcheance = Number(value) > 0;

      if ((Number(value) === 1 &&
        this.modeFacturation.periodicite.id !== 'P' &&
        this.modeFacturation.periodicite.id !== 'A') ||
        (Number(value) !== 1 && this.modeFacturation.periodicite.id === 'P')) {
        this.isEcheance = false;
      }
    }
  }

  // Periodicite des factures
  public getPeriodicite(e: any): void {

    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.typePeriodicite.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.periodicite = { id: option.value, value: option.text };

    if ((this.modeFacturation.nbreOccurence === 1 && e.target.value !== 'P' && e.target.value !== 'A') ||
      (this.modeFacturation.nbreOccurence !== 1 && e.target.value === 'P')) {
      this.isEcheance = false;
    } else {
      this.isEcheance = this.modeFacturation.nbreOccurence > 0;
    }

  }


  // Date de la premiere echeance de reglement
  public updateDateReglement(): void {
    this.modeFacturation.dateReglement = this.dateReglement(this.modeFacturation);
    this.dateR = this.dateService.ToString(this.modeFacturation.dateReglement, 'dd/MM/yyyy');
  }

  public dateReglement(modeFacturation: ModeDeFacturation): QueovalDate {
    let date: Date | null = new Date();    
    if (!this.dateService.IsNull(modeFacturation.dateDebutFacturation) && modeFacturation.dateDebutFacturation) {
      date = this.dateService.ToDate(modeFacturation.dateDebutFacturation);
    }  

    if (date !== null) {
      if (modeFacturation.reglementMoisPlus1 && modeFacturation.jourReglement > 0) {
        date.setDate(1);
        date.setMonth(date.getMonth() + 1);
        date.setDate(Number(modeFacturation.jourReglement));
      } else if (modeFacturation.reglementMoisPlus1 && modeFacturation.jourReglement === 0) {
        date.setDate(1);
        date.setMonth(date.getMonth() + 1);
        date.setDate(Number(date.getDate()) - 1);
      } else if (!modeFacturation.reglementMoisPlus1) {
        date.setDate(Number(date.getDate()) + Number(modeFacturation.jourReglement));
      }
    }

    return this.dateService.FromDate(date)    

  }


  // Delai de reglement: Date emission ou Fin de mois
  public checkChange(value: boolean): void {
    this.modeFacturation.reglementMoisPlus1 = value;
    this.modeFacturation.dateReglement = this.dateReglement(this.modeFacturation);
    this.dateR = this.dateService.ToString(this.modeFacturation.dateReglement, 'dd/MM/yyyy');
  }

  // Nombre de jour
  public changeDay(value: string): void {
    this.isNbJour = value !== '';
    if (value !== '') {
      this.modeFacturation.jourReglement = Number(value);
      this.modeFacturation.dateReglement = this.dateReglement(this.modeFacturation);
      this.dateR = this.dateService.ToString(this.modeFacturation.dateReglement, 'dd/MM/yyyy');
    }
  }

  // Type
  public getModeReglement(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.modeReglement.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.modeReglement = { id: option.value, value: option.text };
    this.isModeReglement = this.modeFacturation.modeReglement.id !== '0';
  }

  // Nombre de reglement par facture
  public changeNbOccurReg(value: string): void {
    this.isOccurenceReglement = value !== '';
    if (value !== '') {
      this.isOccurenceReglement = Number(value) > 0;
    }
  }
  // Periodicite des reglements
  public getPeriodiciteReglement(e: any): void {
    const option: Options = { value: e.target.value, text: this.modeFacturationDisplay.typePeriodicite.filter((c: Select) => c.id === e.target.value)[0].value };
    this.modeFacturation.periodiciteReglement = { id: option.value, value: option.text };
  }


  /**
   * Méthode de vérification des inputs
   */
  public validation(): boolean {

    // Méthode private à validation permettant d'assigner une nouvelle valeur à une propriété
    function testValidation(id: string): boolean {
      if (id === '0' || id === '') {
        return false;
      } else {
        return true;
      }
    }

    let isValid: boolean;
    // Vérification de l'entité    
    let returnValid: boolean = true;
    isValid = testValidation(this.modeFacturation.entiteFacturation.id);
    if (!isValid) {
      this.isEntite = false;
      returnValid = false;
    } else {
      this.isEntite = true;
    }

    var entiteSelected: Array<Entite> = this.modeFacturationDisplay.entite.filter((e: Entite) => e.id === this.modeFacturation.entiteFacturation.id);
    if (!(entiteSelected && entiteSelected.length > 0)) {
      this.isEntite = false;
      //this.userEntiteBloquee = ` bloquée pour l'utilisateur.`;
      //this.labelEntite = `Entité pour l'utilisateur est fixée sur :`;
      returnValid = false;
    }

    //  Vérification du groupe
    isValid = testValidation(this.modeFacturation.groupeFacturation.id);
    if (!isValid) {
      this.isGroupe = false;
      returnValid = false;
    } else {
      this.isGroupe = true;
    }
    // Verificaiton de la date premiere emission
    if (!this.isDateDebut) {
      returnValid = false;
    }


    // Article
    isValid = testValidation(this.modeFacturation.article.id);
    if (!isValid) {
      this.isArticle = false;
      returnValid = false;
    } else {
      this.isArticle = true;
    }

    // Nombre de factures
    if (this.modeFacturation.nbreOccurence === null || (this.modeFacturation.nbreOccurence !== null && this.modeFacturation.nbreOccurence <= 0 )) {
      this.isEcheance = false;
      returnValid = false;
    }

    // Mode echeancier de facture
    if ((this.modeFacturation.nbreOccurence === 1 &&
      this.modeFacturation.periodicite.id !== 'P' &&
      this.modeFacturation.periodicite.id !== 'A') ||
      (this.modeFacturation.nbreOccurence !== 1 &&
        this.modeFacturation.periodicite.id === 'P')) {
      this.isEcheance = false;
      returnValid = false;
    }


    // Vérification du mode de réglement
    isValid = testValidation(this.modeFacturation.modeReglement.id);
    if (!isValid) {
      this.isModeReglement = false;
      returnValid = false;
    } else {
      this.isModeReglement = true;
    }

    // Verification nb jour reglement
    if (!(this.modeFacturation.jourReglement !== null && (this.modeFacturation.jourReglement >= 0 && this.isNbJour))) {
      returnValid = false;
    }

    // Verification nb echeance reglement
    if (!(this.modeFacturation.nbreOccurenceReglement !== null && (this.modeFacturation.nbreOccurenceReglement > 0 && this.isOccurenceReglement))) {
      returnValid = false;
    }

    return returnValid;
  }

  // #endregion


}
